import {ContinentCodes, CountryCodes, RegionCodes, GeographicalRegionNames} from '@colonist/leaderboard-types'

export class GeographicalInformationConverter {
    static readonly allContinents = Object.keys(GeographicalRegionNames) as ContinentCodes[]
    static readonly allCountryCodes = this.allContinents.flatMap((continentCode) => this.getCountryCodesInContinent(continentCode))
    private static readonly allCountryCodesSet = new Set(this.allCountryCodes)

    static getContinentCodeFromCountryCode(countryCode: CountryCodes): ContinentCodes | undefined {
        return this.allContinents
            .find((continentCode) => this.isCountryInContinent(continentCode, countryCode))
    }

    static isValidContinentCode(continentCode: any): continentCode is ContinentCodes {
        return GeographicalRegionNames[continentCode] != undefined
    }

    static isValidCountryCode(countryCode: any): countryCode is CountryCodes {
        return this.allCountryCodesSet.has(countryCode)
    }

    static isValidRegionCode(countryCode: CountryCodes, regionCode: any): regionCode is RegionCodes {
        const continent = this.getContinentCodeFromCountryCode(countryCode)
        if(continent == undefined) return false
        return GeographicalRegionNames[continent][countryCode]?.[regionCode] != undefined
    }

    static isValidUntilEmpty(continentCode: ContinentCodes | undefined, countryCode: CountryCodes | undefined, regionCode: RegionCodes | undefined): boolean {
        if(continentCode == undefined) return true
        const continent = GeographicalRegionNames[continentCode]
        if(continent == undefined) return false

        if(countryCode == undefined) return true
        const country = continent[countryCode]
        if(country == undefined) return false

        if(regionCode == undefined) return true
        if(country[regionCode] == undefined) return false

        return true
    }

    static isCountryInContinent(continentCode: ContinentCodes, countryCode: CountryCodes): boolean {
        return GeographicalRegionNames[continentCode]?.[countryCode] != undefined
    }

    static getRegionNameForCountryCodeAndRegionCode(countryCode: CountryCodes, regionCode: RegionCodes): string | undefined {
        const continent = this.getContinentCodeFromCountryCode(countryCode)
        if(continent == undefined) return undefined
        return GeographicalRegionNames[continent][countryCode][regionCode]
    }

    static getCountryCodesInContinent(continentCode: ContinentCodes): CountryCodes[] {
        return Object.keys(GeographicalRegionNames[continentCode]) as CountryCodes[]
    }

    static getRegionCodesInCountry(countryCode: CountryCodes): RegionCodes[] {
        const continent = this.getContinentCodeFromCountryCode(countryCode)
        if(continent == undefined) return []
        const country = GeographicalRegionNames[continent][countryCode]
        return Object.keys(country) as RegionCodes[]
    }
}
